import React from "react";
import { useNavigate } from "react-router-dom";

const PageTitle = (props) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/contact");
  };

  return (
    <section
      className="page-title"
      style={{
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "500px",
        height: "fit-content",
        padding: "0px 0px 50px 0px",
        borderBottomLeftRadius: props.pageTitle !== "Get In touch" ? "50px" : "0px",
        borderBottomRightRadius: props.pageTitle !== "Get In touch" ? "50px" : "0px",
        boxShadow:  props.pageTitle !== "Get In touch"
        ? "0px 4px 12px 0px rgba(210, 111, 216, 0.7)"
        : "none",
      }}
    >
      <div className="page-inner-wrap">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <h2 style={{ color: "white" }}>{props.pageTitle}</h2>
              <p style={{ color: "white", fontSize: "20px" }}>
                {props.pageSub}
              </p>
            </div>
            {props.buttonText ? (
              <div>
                <button
                  style={{
                    fontWeight: "700",
                    backgroundColor: "#2D30AB",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "30px",
                    border: "none",
                  }}
                  onClick={handleButtonClick}
                >
                  {props?.buttonText}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
